// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3tpDi","author":"Table_author__K9kuo","authorImage":"Table_authorImage__1H0f2","unreadRow":"Table_unreadRow__2_aFB"};